function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M224,288c79.5,0,144-64.5,144-144S303.5,0,224,0S80,64.5,80,144S144.5,288,224,288z M224,48c52.9,0,96,43.1,96,96 s-43.1,96-96,96s-96-43.1-96-96S171.1,48,224,48z M313.6,304c-28.7,0-42.5,16-89.6,16s-60.8-16-89.6-16C60.2,304,0,364.2,0,438.4 V464c0,26.5,21.5,48,48,48h352c26.5,0,48-21.5,48-48v-25.6C448,364.2,387.8,304,313.6,304z M400,464H48v-25.6 c0-47.6,38.8-86.4,86.4-86.4c14.6,0,38.3,16,89.6,16c51.7,0,74.9-16,89.6-16c47.6,0,86.4,38.8,86.4,86.4V464z M624,88h-72V16 c0-8.8-7.2-16-16-16h-16c-8.8,0-16,7.2-16,16v72h-72c-8.8,0-16,7.2-16,16v16c0,8.8,7.2,16,16,16h72v72c0,8.8,7.2,16,16,16h16 c8.8,0,16-7.2,16-16v-72h72c8.8,0,16-7.2,16-16v-16C640,95.2,632.8,88,624,88z"
});

var SvgUserPlusRegularLs = function SvgUserPlusRegularLs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    focusable: "false",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 512",
    style: {
      enableBackground: "new 0 0 640 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUserPlusRegularLs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user-plus-regular-ls.a35bca96.svg";
export { ForwardRef as ReactComponent };